import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=70189f29&scoped=true&"
import script from "./setting.js?vue&type=script&lang=js&"
export * from "./setting.js?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=70189f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70189f29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70189f29')) {
      api.createRecord('70189f29', component.options)
    } else {
      api.reload('70189f29', component.options)
    }
    module.hot.accept("./setting.vue?vue&type=template&id=70189f29&scoped=true&", function () {
      api.rerender('70189f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/scm/setting/setting.vue"
export default component.exports